module.exports = __webpack_public_path__ + "static/media/eye.18421c1a.svg";